import React, { useCallback, useEffect, useState } from "react";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import { Grid } from "src/shared/grid";
import { getNfdrCatalog } from 'src/apis/getWeatherCalls';
import { useStoreContext } from 'src/store/context';
import { useAddAlert } from 'src/store/actions';
import { alertMessages } from 'src/constants';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { TableHead } from "@mui/material";

export const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',

  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

type CatalogProps = {
    station: any
}

export const CatalogTab: React.FC<CatalogProps> = ({ station}) =>{

  const [, dispatch ] = useStoreContext();
  const addAlert = useAddAlert(dispatch);
  const [stationMeta, setStationMeta] = useState<any>(null);
  const getMeta = useCallback((station:any) =>{

  (async()=>{
    const {station_id} = station;
    try{
      const varRequest = {
        stationId: station_id.toString()			
      };
      const response: any = await getNfdrCatalog(varRequest, addAlert);
      if(response){
        setStationMeta(response);
      }
    }
    catch(error){
      console.log('error', error)
      addAlert({
        id:'',
        message: alertMessages.retrievingStationData,
        type:'error-info',
        icon:'fa-exclamation-triangle'
      })
    }
  })();
},[addAlert, setStationMeta]);


useEffect(() => {
  if (station?.station_id) {
    getMeta(station);
  }
}, [station, getMeta]);

const safeStationMeta = stationMeta?.[0] || {};

  return (
    <Box sx={{ width: '99%' }}>
      <div style={{ paddingBottom: '1rem' }}>
        <Divider />

        <Grid row gap="md" style={{padding: '.5rem', backgroundColor: '#dddddd'}}>
          <Grid
            desktop={{ col: 3 }}
            style={{justifyContent: 'center'}}
            className="display-flex flex-row flex-align-center flex-justify ">
              <div style={{ textAlign: 'center' }}>
              <span className="font-sans-sm text-bold" style={{ fontSize: '1rem', textTransform: 'uppercase' }}>Drought Catalog</span>

              </div>
          </Grid>
          <Grid
            desktop={{ col: 3 }}            
            style={{justifyContent: 'center'}}
            className="display-flex flex-row flex-align-center flex-justify">
            <span className="font-sans-sm text-bold" style={{ fontSize: '1rem', textTransform: 'uppercase' }}>Dead Fuel Catalog</span>
          </Grid>
          <Grid
            desktop={{ col: 2 }}
            style={{justifyContent: 'center'}}
            className="display-flex flex-row flex-align-center flex-justify">
            <span className="font-sans-sm text-bold" style={{ fontSize: '1rem', textTransform: 'uppercase' }}>Live Fuel Catalog</span>
          </Grid>
          <Grid
            desktop={{ col: 2 }}
            style={{justifyContent: 'center'}}
            className="display-flex flex-row flex-align-center flex-justify">
            <span className="font-sans-sm text-bold" style={{ fontSize: '1rem', textTransform: 'uppercase' }}>Fuel Model Catalog</span>
          </Grid>
          <Grid
            desktop={{ col: 2 }}
            style={{justifyContent: 'center'}}

            className="display-flex flex-row flex-align-center flex-justify">
            <span className="font-sans-sm text-bold" style={{ fontSize: '1rem', textTransform: 'uppercase' }}>Fuel Model</span>
          </Grid>
        </Grid>
        <Divider />
        <Grid row gap="md" style={{backgroundColor: 'white', padding: '.75rem'}}>
          <Grid
            desktop={{ col: 3 }}
            style={{justifyContent: 'center'}}
            className="display-flex flex-row flex-align-center flex-justify">

          <span
            className="font-sans-sm"
            style={{ fontSize: '.9rem', textTransform: 'uppercase' }}
          >
            {safeStationMeta.kbdi_parameter_catalog_name}
          </span>

          </Grid>
          <Grid
            desktop={{ col: 3 }}
            style={{justifyContent: 'center'}}
            className="display-flex flex-row flex-align-center flex-justify">
            <span className="font-sans-sm" style={{ fontSize: '.9rem', textTransform: 'uppercase' }}>{safeStationMeta.dead_fuel_parameter_catalog_name }</span>
          </Grid>
          <Grid
            desktop={{ col: 2 }}
            style={{justifyContent: 'center'}}
            className="display-flex flex-row flex-align-center flex-justify">
            <span className="font-sans-sm" style={{ fontSize: '.9rem', textTransform: 'uppercase' }}>{safeStationMeta.catalog_name }</span>
          </Grid>
          <Grid
            desktop={{ col: 2 }}
            style={{justifyContent: 'center'}}
            className="display-flex flex-row flex-align-center flex-justify">
            <span className="font-sans-sm" style={{ fontSize: '.9rem', textTransform: 'uppercase' }}>{safeStationMeta?.fire_danger_model_name?.split('NFDRS')[0]}</span>
          </Grid>
          <Grid
            desktop={{ col: 2 }}
            style={{justifyContent: 'center'}}
            className="display-flex flex-row flex-align-center flex-justify">
            <span className="font-sans-sm" style={{ fontSize: '.9rem', textTransform: 'uppercase' }}>
            {Array.isArray(stationMeta) && stationMeta.length > 0
                ? stationMeta
                    .map((item) => item.fuel_model)
                    .filter(Boolean)
                    .join(', ')
                : ''}
            </span>
          </Grid>
        </Grid>
      </div>
      <Stack spacing={1}>
        {/** drought catalog items*/}

        <Item style={{marginBottom: '10px'}}>
          <div style={{ padding: '1rem' }}>
            <div style={{ textAlign: 'left' }}>
              <span className="font-sans-lg text-bold" >
                Drought Catalog
              </span>
            </div>
            <Divider variant="middle" style={{borderWidth: '.4px', marginTop: '5px', marginBottom: '5px'}}/>

            <Grid row gap="md">
              <Grid
                desktop={{ col: 3 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>CATALOG NAME</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>KBDI THRESHOLD</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>INITIAL KBDI</span>
              </Grid>
            </Grid>
            <Grid row gap="md">
              <Grid
                desktop={{ col: 3 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>{safeStationMeta.kbdi_parameter_catalog_name }</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>{safeStationMeta.kbdi_threshold }</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>{safeStationMeta.kbdi_initial }</span>
              </Grid>
            </Grid>
          </div>
        </Item>
        <Item style={{marginBottom: '10px'}}>
          <div style={{ padding: '1rem' }}>
            <div style={{ textAlign: 'left' }}>
              <span className="font-sans-lg text-bold" >
                Dead Fuel Catalog
              </span>
            </div>
            <Divider variant="middle" style={{borderWidth: '.4px', marginTop: '5px', marginBottom: '5px'}}/>

            <Grid row gap="md">
              <Grid
                desktop={{ col: 3 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>CATALOG NAME</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>1 hr fuel moisture stick radius</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>10 hr fuel moisture stick radius</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>100 hr fuel moisture stick radius</span>
              </Grid>
              <Grid
                desktop={{ col: 3 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>1000 hr fuel moisture stick radius</span>
              </Grid>
            </Grid>
            <Grid row gap="md">
              <Grid
                desktop={{ col: 3 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>{safeStationMeta.dead_fuel_parameter_catalog_name }</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>{safeStationMeta.stick_radius_1_hr_fuel_moisture }</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>{safeStationMeta.stick_radius_10_hr_fuel_moisture }</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>{safeStationMeta.stick_radius_100_hr_fuel_moisture }</span>
              </Grid>
              <Grid
                desktop={{ col: 3 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>{safeStationMeta.stick_radius_1000_hr_fuel_moisture }</span>
              </Grid>
            </Grid>
          </div>
        </Item>
        <Item style={{marginBottom: '10px'}}>
          <div style={{ padding: '1rem'}}>
            <div style={{ textAlign: 'left' }}>
              <span className="font-sans-lg text-bold" >
                Live Fuel Catalog
              </span>
            </div>



            <Divider variant="middle" style={{borderWidth: '.4px', marginTop: '10px', marginBottom: '15px'}}/>
            <Grid row gap="md">
              <Grid
                desktop={{ col: 3 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '15px', textTransform: 'uppercase' }}>CATALOG NAME</span>
              </Grid>
            </Grid>
            <Grid row gap="md" style={{paddingBottom: '10px'}}>
              <Grid
                desktop={{ col: 3 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '13px', textTransform: 'uppercase' }}>{safeStationMeta.catalog_name}</span>
              </Grid>
            </Grid>

            <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <div style={{fontWeight: 700, fontSize: '20px', width: '48%', textAlign: 'left'}}>Herbaceous</div>
            <div style={{fontWeight: 700, fontSize: '20px', width: '48%', textAlign: 'left'}}>Woody</div>

            </div>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <TableContainer component={Paper} sx={{width: '48%'}}>
              <Table aria-label="simple table" sx={{ '& .MuiTableCell-root': { border: '1px solid rgba(224, 224, 224, 1)' } }}>
              <colgroup>
                  <col width="50%" />
                  <col width="50%" />
              </colgroup>
                <TableBody>
                  <TableRow>
                    <TableCell style={{backgroundColor: '#f2f2f5'}}>Herbaceous Temp Min Min</TableCell>
                    <TableCell style={{backgroundColor: '#f2f2f5'}} align="left">{safeStationMeta.herb_temp_min_min}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell >Herbaceous Temp Min Max</TableCell>
                    <TableCell align="left">{safeStationMeta.herb_temp_min_max}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell style={{backgroundColor: '#f2f2f5'}}>Herbaceous Day Length Min</TableCell>
                    <TableCell style={{backgroundColor: '#f2f2f5'}} align="left">{safeStationMeta.herb_day_length_min}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell >Herbaceous Day Length Max</TableCell>
                    <TableCell align="left">{safeStationMeta.herb_day_length_max}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell style={{backgroundColor: '#f2f2f5'}}>Herbaceous VPD Avg Flag</TableCell>
                    <TableCell style={{backgroundColor: '#f2f2f5'}} align="left">{safeStationMeta.herb_vpd_avg_flg}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell >Herbaceous Days Avg</TableCell>
                    <TableCell align="left">{safeStationMeta.herb_days_avg}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell style={{backgroundColor: '#f2f2f5'}}>Herbaceous Max GSI</TableCell>
                    <TableCell style={{backgroundColor: '#f2f2f5'}} align="left">{safeStationMeta.herb_max_gsi}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell >Herbaceous Greenup Threshold</TableCell>
                    <TableCell align="left">{safeStationMeta.herb_greenup}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell style={{backgroundColor: '#f2f2f5'}}>Herbaceous FM Max</TableCell>
                    <TableCell style={{backgroundColor: '#f2f2f5'}} align="left">{safeStationMeta.herb_max}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell >Herbaceous FM Min</TableCell>
                    <TableCell align="left">{safeStationMeta.herb_min}</TableCell>
                  </TableRow>


                  <TableRow>
                    <TableCell style={{backgroundColor: '#f2f2f5'}}>Herbaceous Running Precip Total Min</TableCell>
                    <TableCell style={{backgroundColor: '#f2f2f5'}} align="left">{safeStationMeta.herb_precip_total_min}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell >Herbaceous Running Precip Total Max</TableCell>
                    <TableCell align="left">{safeStationMeta.herb_precip_total_max}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{backgroundColor: '#f2f2f5'}}>Herbaceous Running Total Precip Days</TableCell>
                    <TableCell style={{backgroundColor: '#f2f2f5'}} align="left">{safeStationMeta.herb_total_precip_days}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell >Herbaceous Use Precip Flag</TableCell>
                    <TableCell align="left">{safeStationMeta.herb_use_precip_flg}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{backgroundColor: '#f2f2f5'}}>Herbaceous Calibration</TableCell>
                    <TableCell style={{backgroundColor: '#f2f2f5'}} align="left">{safeStationMeta.herb_calibration==='0'? 'Off': 'On'}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>


            <TableContainer component={Paper} sx={{width: '48%'}}>
              <Table aria-label="simple table" sx={{ '& .MuiTableCell-root': { border: '1px solid rgba(224, 224, 224, 1)' } }}>
              <colgroup>
                  <col width="50%" />
                  <col width="50%" />
              </colgroup>
                <TableBody>
                  <TableRow>
                    <TableCell style={{backgroundColor: '#f2f2f5'}}>Woody Temp Min Min</TableCell>
                    <TableCell style={{backgroundColor: '#f2f2f5'}} align="left">{safeStationMeta.woody_temp_min_min}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell >Woody Temp Min Max</TableCell>
                    <TableCell align="left">{safeStationMeta.woody_temp_min_max}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell style={{backgroundColor: '#f2f2f5'}}>Woody Day Length Min</TableCell>
                    <TableCell style={{backgroundColor: '#f2f2f5'}} align="left">{safeStationMeta.woody_day_length_min}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell >Woody Day Length Max</TableCell>
                    <TableCell align="left">{safeStationMeta.woody_day_length_max}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell style={{backgroundColor: '#f2f2f5'}}>Woody VPD Avg Flag</TableCell>
                    <TableCell style={{backgroundColor: '#f2f2f5'}} align="left">{safeStationMeta.woody_vpd_avg_flg}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell >Woody Days Avg</TableCell>
                    <TableCell align="left">{safeStationMeta.woody_days_avg}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell style={{backgroundColor: '#f2f2f5'}}>Woody Max GSI</TableCell>
                    <TableCell style={{backgroundColor: '#f2f2f5'}} align="left">{safeStationMeta.woody_max_gsi}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell >Woody Greenup Threshold</TableCell>
                    <TableCell align="left">{safeStationMeta.woody_greenup}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell style={{backgroundColor: '#f2f2f5'}}>Woody FM Max</TableCell>
                    <TableCell style={{backgroundColor: '#f2f2f5'}} align="left">{safeStationMeta.woody_max}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell >Woody FM Min</TableCell>
                    <TableCell align="left">{safeStationMeta.woody_min}</TableCell>
                  </TableRow>


                  <TableRow>
                    <TableCell style={{backgroundColor: '#f2f2f5'}}>Woody Running Precip Total Min</TableCell>
                    <TableCell style={{backgroundColor: '#f2f2f5'}} align="left">{safeStationMeta.woody_precip_total_min}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell >Woody Running Precip Total Max</TableCell>
                    <TableCell align="left">{safeStationMeta.woody_precip_total_max}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{backgroundColor: '#f2f2f5'}}>Woody Running Total Precip Days</TableCell>
                    <TableCell style={{backgroundColor: '#f2f2f5'}} align="left">{safeStationMeta.woody_total_precip_days}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell >Woody Use Precip Flag</TableCell>
                    <TableCell align="left">{safeStationMeta.woody_use_precip_flg}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{backgroundColor: '#f2f2f5'}}>Woody Calibration</TableCell>
                    <TableCell style={{backgroundColor: '#f2f2f5'}} align="left">{safeStationMeta.woody_calibration==='0'? 'Off': 'On'}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            </div>
          </div>
        </Item>
        <Item style={{ marginBottom: '10px' }}>
          <div style={{ padding: '1rem' }}>
            <div style={{ textAlign: 'left' }}>
              <span className="font-sans-lg text-bold">Fuel Model Catalog</span>
            </div>
            <Divider
              variant="middle"
              style={{ borderWidth: '.4px', marginTop: '2px', marginBottom: '2px' }}
            />

            <TableContainer component={Paper} sx={{ width: '100%', paddingTop: '10px' }}>
              <Table aria-label="simple table" >
                {/* <colgroup>
                  <col width="50%" />
                  <col width="50%" />
              </colgroup> */}
                <TableHead>
                  <TableRow >
                    <TableCell style={{ fontWeight: 700, fontSize: '16px' }}>Catalog Name</TableCell>
                    <TableCell style={{ fontWeight: 700, fontSize: '16px' }} align="left">Model Type</TableCell>
                    <TableCell style={{ fontWeight: 700, fontSize: '16px' }} align="left">Slope Class</TableCell>
                    <TableCell style={{ fontWeight: 700, fontSize: '16px' }} align="left">SCM</TableCell>
                    <TableCell style={{ fontWeight: 700, fontSize: '16px' }} align="left">Grass Class</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stationMeta?.map((item, index) => (

                    index % 2 === 0 ?
                      <TableRow key={`${item.fire_danger_model_name}-${index}`}>
                        <TableCell style={{ backgroundColor: '#f2f2f5' }}>{item.fire_danger_model_name}</TableCell>
                        <TableCell style={{ backgroundColor: '#f2f2f5' }} align="left">{item.fuel_model}</TableCell>
                        <TableCell style={{ backgroundColor: '#f2f2f5' }} align="left">{item.slope_class}</TableCell>
                        <TableCell style={{ backgroundColor: '#f2f2f5' }} align="left">{item.scm}</TableCell>
                        <TableCell style={{ backgroundColor: '#f2f2f5' }} align="left">{item.grass_type}</TableCell>
                      </TableRow>
                      :
                      <TableRow key={`${item.fire_danger_model_name}-${index}`}>
                        <TableCell >{item.fire_danger_model_name}</TableCell>
                        <TableCell align="left">{item.fuel_model}</TableCell>
                        <TableCell align="left">{item.slope_class}</TableCell>
                        <TableCell align="left">{item.scm}</TableCell>
                        <TableCell align="left">{item.grass_type}</TableCell>
                      </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Item>
      </Stack>
    </Box>
  );
}
